export var browserDetect = {
    platformAndroid: function () {
        return !!navigator.userAgent.match(/Android/i);
    },
    platformBlackBerry: function () {
        return !!navigator.userAgent.match(/BlackBerry/i);
    },
    platformIOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i)
            ? true
            : navigator.maxTouchPoints > 0 && typeof window.orientation !== 'undefined';
    },
    platformWindows: function () {
        return !!navigator.userAgent.match(/IEMobile/i);
    },
    isIPhone: function () {
        return navigator.userAgent.match(/iPhone|iPod/i)
            ? true
            : navigator.maxTouchPoints > 0 && typeof window.orientation !== 'undefined';
    },
    isIpad: function () {
        return navigator.userAgent.match(/iPad/i)
            ? true
            : navigator.maxTouchPoints > 0 && typeof window.orientation !== 'undefined';
    },
    // Modern iPadOS Safari reports a desktop "Macintosh" user agent (no "iPad"
    // token) and removed window.orientation, so platformIOS()/isIpad() miss it.
    // Detect a touch-capable Mac (iPad masquerading as macOS) explicitly.
    isIpadOS: function () {
        return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    },
    // True for any WebKit/Safari (desktop Safari, iPhone, and iPad — including
    // iPadOS reporting as macOS). Excludes Chrome/Edge/Firefox-on-iOS which also
    // embed "Safari" in their UA. Used to branch clipboard/gesture-sensitive
    // paths, since all Safari variants expire the user-gesture on any await
    // before navigator.clipboard.write().
    isSafari: function () {
        var ua = navigator.userAgent;
        var isRealSafari = /^((?!chrome|chromium|crios|android|fxios|edg|edgios|opr|opera).)*safari/i.test(ua);
        return isRealSafari || browserDetect.isIpadOS();
    },
    isMobile: function () {
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.search('android') > -1 && userAgent.search('mobile') > -1)
            return true;
        else if (userAgent.search('android') > -1 && !(userAgent.search('mobile') > -1))
            return false;
        else
            return /iphone|ipod|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile/i.test(userAgent);
    },
    isTablet: function () {
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.search('android') > -1 && !(userAgent.search('mobile') > -1))
            return true;
        else if (browserDetect.isIpad())
            return true;
        else
            return /ipad|android|android 3.0|xoom|sch-i800|playbook|tablet|kindle/i.test(userAgent.toLowerCase());
    },
    isDevice: function () {
        return (browserDetect.platformAndroid() ||
            browserDetect.platformBlackBerry() ||
            browserDetect.platformIOS() ||
            browserDetect.platformWindows());
    },
    ie9: function () {
        return !!navigator.userAgent.match(/MSIE 9.0/i);
    },
    ie10: function () {
        return !!navigator.userAgent.match(/MSIE 10.0/i);
    },
    ie: function () {
        return (navigator.appName === 'Microsoft Internet Explorer' ||
            !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)) ||
            navigator.userAgent.indexOf('MSIE') > 0 ||
            !!navigator.userAgent.match(/Edge\/\d./i) ||
            !!navigator.userAgent.match(/MSIE 9.0/i) ||
            !!navigator.userAgent.match(/MSIE 10.0/i));
    },
    getOrientation: function () {
        var returnObj = {
            type: 'D', // values - M - Mobile / T - tablet / D - Desktop / Othe - not yet recognised as device or desktop
        };
        if (browserDetect.isDevice()) {
            returnObj.orientation = window.orientation === 0 ? 'P' : 'L';
            returnObj.type = browserDetect.isMobile() ? 'M' : browserDetect.isTablet() ? 'T' : 'Other';
        }
        return returnObj;
    },
};
